var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noneData"},[_c('img',{attrs:{"src":require("@/assets/img/notData/404.png"),"alt":""}}),_c('p',[_vm._v("该课程已下架，无法查看")])])
}]

export { render, staticRenderFns }